import request from './base/api';

/**
 * 購物網站登入 API
 * @param {Object} params - 包含 phone 和 password 的物件
 * @param {function} cb - 成功回調函式
 * @param {function} errCb - 失敗回調函式
 */
export function login({ phone, password }, cb, errCb) {
  return request({
    url: 'shopping/login',
    method: 'post',
    config: {
      data: {
        phone,
        password
      }
    },
    cb,
    errCb
  });
}

/**
 * 購物網站註冊 API
 * @param {Object} params - 包含 name, gender, birthday, phone, email, password 的物件
 * @param {function} cb - 成功回調函式
 * @param {function} errCb - 失敗回調函式
 */
export function register(params, cb, errCb) {
  return request({
    url: 'shopping/register',
    method: 'post',
    config: {
      data: params
    },
    cb,
    errCb
  });
}

export default {
  login,
  register
};
